import { useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { Layer } from '@/layers/layer';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;
    const disabled = !layer;
    if (disabled) return null;

    const clickHandler = (type: string) => {
        const dependenciesAPI = framework.getInstance(Layer);
        dependenciesAPI.canvasAlign[type]?.(activeLayer?.id);
    };

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.alignCanvas),
        type: 'alignCanvas',
        childMenus: [
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignLeft),
                type: 'left',
                icon: 'AlignLeftBold',
                onClick: () => clickHandler('left'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignHorizontal),
                type: 'horizontalCenter',
                icon: 'AlignHorizontalCenterBold',
                onClick: () => clickHandler('horizontalCenter'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignRight),
                type: 'right',
                icon: 'AlignRightBold',
                onClick: () => clickHandler('right'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignTop),
                type: 'top',
                icon: 'AlignTopBold',
                onClick: () => clickHandler('top'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignVertical),
                type: 'verticalCenter',
                icon: 'AlignVerticalCenterBold',
                onClick: () => clickHandler('verticalCenter'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignBottom),
                type: 'bottom',
                icon: 'AlignBottomBold',
                onClick: () => clickHandler('bottom'),
            },
        ],
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 4,
    sort: 1,
    render,
} as IExportContextMenuItem;
